module.exports = {
      id: "share-pintrest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#share-pintrest",
      toString: function () {
        return this.url;
      }
    }